exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".cart-subtotal {\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  background-color: #fff;\n  color: rgba(0, 0, 0, 0.54);\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  font-size: 12px;\n  font-weight: 600;\n  height: 40px;\n  -webkit-box-pack: end;\n      -ms-flex-pack: end;\n          justify-content: flex-end;\n  padding: 0 16px;\n  position: relative; }\n  .cart-subtotal .subtotal {\n    color: #ffa000;\n    font-size: 16px;\n    font-weight: bold;\n    padding-left: 16px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/iangoldfarb/Desktop/SupplyHub/shFrontEnd/src/app/navbar/shopping-cart/cart-subtotal/cart-subtotal.component.scss
// module id = ../../../../../src/app/navbar/shopping-cart/cart-subtotal/cart-subtotal.component.scss
// module chunks = main